export default "__VITE_ASSET__CW3bYRQ9__"